/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Online_H1Inputs */

const en_vc_page_online_h1 = /** @type {(inputs: Vc_Page_Online_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft online: a free vector editor in your browser`)
};

const zh_vc_page_online_h1 = /** @type {(inputs: Vc_Page_Online_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 在线版：浏览器里的免费矢量编辑器`)
};

/**
* | output |
* | --- |
* | "VectorCraft online: a free vector editor in your browser" |
*
* @param {Vc_Page_Online_H1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_online_h1 = /** @type {((inputs?: Vc_Page_Online_H1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Online_H1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_online_h1(inputs)
	return zh_vc_page_online_h1(inputs)
});
export { vc_page_online_h1 as "vc.page.online.h1" }